import React, { Component, type ErrorInfo, type ReactNode } from "react";
import "./error-boundary.css";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = {
    hasError: false,
    error: null,
  };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("Unhandled portal rendering error:", error, errorInfo);
  }

  private handleReload = (): void => {
    window.location.reload();
  };

  private handleDashboard = (): void => {
    window.location.assign("/");
  };

  render(): ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="portal-error-page" role="alert">
        <section className="portal-error-card">
          <div className="portal-error-label">GIISDEC GIIP</div>

          <h1>Unable to open this page</h1>

          <p>
            The page encountered an unexpected problem. Reload the page or
            return to the portal dashboard.
          </p>

          {this.state.error && (
           <pre className="portal-error-details">
            {this.state.error.stack || this.state.error.message}
          </pre>
        )}

          <div className="portal-error-actions">
            <button type="button" onClick={this.handleReload}>
              Reload page
            </button>

            <button
              type="button"
              className="secondary"
              onClick={this.handleDashboard}
            >
              Return to dashboard
            </button>
          </div>
        </section>
      </main>
    );
  }
}

export default ErrorBoundary;
